import { useQuery } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";
import MarkerListMap, { MarkerObject } from "components/Maps/MarkerListMap";
import { BuildingContext } from "Context/BuildingProvider";
import { FloorOverlay, GetFloorOverlaysQueryResult } from "generated/graphql";
import { GET_FLOOR_OVERLAYS } from "lib/buildings";
import React, { useContext } from "react";
import PlaybackControl from "./PlaybackControl";

interface PlaybackMapProps {
  markers: MarkerObject[];
}
export default function PlaybackMap({ markers }: PlaybackMapProps) {
  const { currentBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetFloorOverlaysQueryResult = useQuery(
    GET_FLOOR_OVERLAYS,
    {
      variables: {
        buildingId: currentBuilding?.Id,
      },
    }
  );

  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else if (!!data) {
    return (
      <MarkerListMap
        mapId="playbackMap"
        markers={markers}
        floorOverlays={data.FloorOverlay}
      />
    );
  } else {
    return <LinearProgress />;
  }
}
